import React from 'react';

const CustomerForm = ({
  customerName,
  setCustomerName,
  email,
  setEmail,
  phone,
  setPhone,
  address,
  setAddress,
  companyName,
  setCompanyName,
  formErrors
}) => {
  return (
    <div className="col-md-8">
      <div className="mb-3">
        <label className="form-label">Full Name *</label>
        <input 
          type="text" 
          className={`form-control ${formErrors.customerName ? 'is-invalid' : ''}`} 
          value={customerName} 
          onChange={(e) => setCustomerName(e.target.value)} 
          required 
        />
        {formErrors.customerName && (
          <div className="invalid-feedback">{formErrors.customerName}</div>
        )}
      </div>
      <div className="mb-3">
        <label className="form-label">Email *</label>
        <input 
          type="email" 
          className={`form-control ${formErrors.email ? 'is-invalid' : ''}`} 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          required 
        />
        {formErrors.email && (
          <div className="invalid-feedback">{formErrors.email}</div>
        )}
      </div>
      <div className="mb-3">
        <label className="form-label">Phone *</label>
        <input 
          type="tel" 
          className={`form-control ${formErrors.phone ? 'is-invalid' : ''}`} 
          value={phone} 
          onChange={(e) => setPhone(e.target.value)} 
          required 
        />
        {formErrors.phone && (
          <div className="invalid-feedback">{formErrors.phone}</div>
        )}
      </div>
      <div className="mb-3">
        <label className="form-label">Address *</label>
        <input 
          type="text" 
          className={`form-control ${formErrors.address ? 'is-invalid' : ''}`} 
          value={address} 
          onChange={(e) => setAddress(e.target.value)} 
          required 
        />
        {formErrors.address && (
          <div className="invalid-feedback">{formErrors.address}</div>
        )}
      </div>
      <div className="mb-3">
        <label className="form-label">Company (optional)</label>
        <input 
          type="text" 
          className="form-control" 
          value={companyName} 
          onChange={(e) => setCompanyName(e.target.value)} 
        />
      </div>
    </div>
  );
};

export default CustomerForm;